import { endpoints } from 'api/endpoints'
import { GetOneResponse } from 'interfaces/api.interfaces'
import { TetrisLogLink, TetrisLogsFileNames } from 'interfaces/api/tetrisLogs.interfaces'
import { axios } from 'modules/axios'

const getAll = async (): GetOneResponse<TetrisLogsFileNames> => {
  const { data: response } = await axios.request<TetrisLogsFileNames>({
    method: 'GET',
    url: endpoints.tetrisLogs.getAll(),
  })
  return response
}

const getLink = async (filename: string): GetOneResponse<TetrisLogLink> => {
  const { data: response } = await axios.request<TetrisLogLink>({
    method: 'GET',
    url: endpoints.tetrisLogs.getLink(),
    params: { filename },
  })
  return response
}

const download = async (url: string): Promise<Blob> => {
  console.log(url)
  const { data } = await axios.request<File>({
    method: 'GET',
    url,
    responseType: 'blob',
  })
  return new Blob([data])
}

export const tetrisLogsApi = {
  getAll,
  getLink,
  download,
}
